export default __webpack_public_path__ + "static/media/Spanish.afce717c.mp3";